<template>
  <ul
    class="navbar-nav ml-auto w-100"
    style="align-items: center"
  >
    <li class="nav-item mr-2 share_lang">
      <LanguageSelectorDropdown />
    </li>

    <li class="nav-item">
      <a
        href="https://www.tenacy.io"
        rel="noopener"
        target="_blank"
      >
        <img
          alt="TENACY"
          class="brand-image pull-right"
          :src="`${publicPath}static/img/Tenacy_couleur_borderless.svg`"
          style="height: 25px !important"
        />
      </a>
      <span class="text-black valign-middle no-mobile pull-right mr-2">
        <translate>Powered by</translate>
      </span>
    </li>
  </ul>
</template>

<script>
import LanguageSelectorDropdown from '@/components/layout/main-header/shared/LanguageSelectorDropdown.vue'

export default {
  name: 'MainHeaderShared',
  components: {
    LanguageSelectorDropdown,
  },
  data() {
    return {
      publicPath: import.meta.env.BASE_URL,
    }
  },
}
</script>

<style lang="scss" scoped>
.share_lang {
  margin-top: -2px !important;
}

.brand-image {
  opacity: 1;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .no-mobile {
    display: none;
  }
}
</style>
